import {Box} from "@mui/material";
import Typography from "@mui/material/Typography";
import Icon from "../../@core/components/icon";
import {IconifyIcon} from "@iconify/types";
import useBgColor from "../../@core/hooks/useBgColor";

interface BoxSelectableProps {
    title: string,
    subtitle?: string,
    icon?: IconifyIcon | string,
    isSelected: boolean,
    onClick?: () => void,
    size?: 'small' | 'medium'
}

const BoxSelectable = ({ size = 'medium', ...props}: BoxSelectableProps) => {
    const bgColors = useBgColor();
    
    const boxContainerStyles = size == 'medium' ? { py: 2.2, px: 6.5 } : { py: 1.5, px: 4.8 };
    const titleProps = size == 'medium' ? { fontSize: '1.025rem !important' } : { fontSize: '0.845rem !important' };
    const subtitleProps = size == 'medium' ? { fontSize: '0.85rem !important' } : { fontSize: '0.685rem !important' };
    
    const iconProps = size == 'medium' ? { fontSize: 35 } : { fontSize: 25 };
    
    return (
        <Box onClick={props.onClick}
            sx={{
                borderRadius: 1,
                cursor: props.onClick ? 'pointer' : 'default',
                ...(props.isSelected ? { ...bgColors.primaryLight } : { backgroundColor: 'action.hover', '&:hover': { backgroundColor: bgColors.primaryLight } }),
                border: theme =>
                    `1px solid ${props.isSelected ? theme.palette.primary.main : theme.palette.divider}`,
                ...boxContainerStyles
            }}>

            <Box
                sx={{
                    rowGap: 1.5,
                    columnGap: 3,
                    display: 'flex',
                    alignItems: 'center',
                    textAlign: ['center', 'start'],
                    flexDirection: ['column', 'row']
                }}
            >
                {
                    props.icon &&
                        <Box sx={{ display: 'flex' }}>
                            <Icon icon={props.icon} {...iconProps} />
                        </Box>
                }
                
                <div>
                    <Typography
                        variant='h6'
                        fontWeight={600}
                        sx={{ ...(props.isSelected ? { color: 'primary.main' } : {}) }}
                        {...titleProps}
                    >
                        {props.title}
                    </Typography>
                    {
                        props.subtitle &&
                            <Typography sx={{ ...(props.isSelected ? { color: 'primary.main' } : {}) }}
                                        {...subtitleProps}
                            >
                                {props.subtitle}
                            </Typography>
                    }
                </div>
            </Box>
        </Box>
    )
}

export default BoxSelectable;